import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Grid, Button, Typography } from '@material-ui/core';
import { withTranslation } from 'react-i18next';
import analytics from '../analytics';

const styles = {
  MuiButton: {
    fontSize: '12px !important',
  },
};

class Footer extends Component {
  render() {
    const { classes, t } = this.props;
    const styles = {
      marginTop: '5rem',
      padding: '1rem',
      paddingBottom: '5rem',
      ...this.props.style,
    };

    return (
      <Grid container style={styles}>
        <Grid
          item
          xs={12}
          style={{
            textAlign: 'center',
          }}
        >
          <Typography
            variant='body2'
            color='secondary'
            style={{
              marginBottom: '1rem',
            }}
          >
            {t('footer.copyright', { start: 2019, year: new Date().getFullYear() })}
          </Typography>
        </Grid>
        <Grid item md={2} lg={2} xl={2}></Grid>
        <Grid
          item
          xs={3}
          md={2}
          lg={2}
          xl={2}
          style={{
            textAlign: 'center',
          }}
        >
          <Button
            className={classes.MuiButton}
            disableRipple={true}
            href='/sell'
            onClick={() => analytics.track("sell_clicked", {})}
          >
            {t('mobile.sell')}
          </Button>
        </Grid>

        <Grid
          item
          xs={3}
          md={2}
          lg={2}
          xl={2}
          style={{
            textAlign: 'center',
          }}
        >
          <Button
            className={classes.MuiButton}
            disableRipple={true}
            href='/legal'
          >
            {t('footer.links.terms')}
          </Button>
        </Grid>

        <Grid
          item
          xs={3}
          md={2}
          lg={2}
          xl={2}
          style={{
            textAlign: 'center',
          }}
        >
          <Button
            className={classes.MuiButton}
            disableRipple={true}
            href='/why-us'
          >
            {t('footer.links.about')}
          </Button>
        </Grid>

        <Grid
          item
          xs={3}
          md={2}
          lg={2}
          xl={2}
          style={{
            textAlign: 'center',
          }}
        >
          <Button
            className={classes.MuiButton}
            disableRipple={true}
            href='/faqs'
          >
            {t('footer.links.faqs')}
          </Button>
        </Grid>
      </Grid>
    );
  }
}

export default withTranslation()(withStyles(styles)(Footer));
